export const eventsData = [
  {
    date: "20 JAN",
    name: "ORIENTATION SYNERGY",
    descripton:
      "Anticipation is in the air! Brace yourselves for an evening filled with excitement and delight surprises at our officail meet on Januaray 20th. Get ready to be amazed as we unfold unexpected moments and celebrate the extraordinary together!",
    venue: "CAMPUS 14, SEMINAR HALL",
    link: "https://www.instagram.com/p/C2RWUf4hOEZ/?igsh=czE0MmpuaG5wb29z",
  },
  {
    date: "28 JAN",
    name: "RECRUITMENT OF 1ST YEAR",
    descripton:
      "Calling all first-years! Join our dynamic society and experience a year filled with fun events and leadership roles. Grow as a person and professionally, while building your college network. It's the perfect way to shape your college experience!",
    venue: "CAMPUS 3, BLOCK B",
    link: "https://www.instagram.com/p/C2d-ztQhZeT/?igsh=dno0Mzk5cDl3d3J5",
  },
  {
    date: "2 MARCH",
    name: "USC KIIT RESEARCH FORUM",
    descripton:
      "Get ready to embark on an exciting journey with the inauguration of the USC KIIT Research Forum! Join us as we dive into collaborative exploration, where your ideas ignite and innovations flourish under the guidance of industry-experienced mentors.",
    venue: "USC KIIT",
    link: "https://www.instagram.com/p/C2RWUf4hOEZ/?igsh=czE0MmpuaG5wb29z",
  },
];
